import { fetchApis, fetchApisCount, fetchApiSlug } from "../../services/api";
import { action, thunk } from "easy-peasy";

export const apiModel = {
  apis: [],
  forFrontPage: [],
  chosenNew: {},
  totalCount: 0,
  pageNumber: 1,
  error: null,
  setError: action((state, payload) => {
    state.error = payload;
  }),
  setApis: action((state, payload) => {
    state.apis = payload;
  }),
  setTotalCount: action((state, payload) => {
    state.totalCount = payload;
  }),
  setPageNumber: action((state, payload) => {
    state.pageNumber = payload;
  }),
  setNew: action((state, payload) => {
    state.chosenNew = payload;
  }),
  getApiSlug: thunk(async (actions, payload) => {
    try {
      const request = await fetchApiSlug(payload);
      if (request && !request.error && request.length > 0)
        actions.setNew(request[0]);
    } catch (err) {
      actions.setError(err);
    }
  }),
  getApis: thunk(async (actions, payload) => {
    try {
      const request = await fetchApis(payload);
      if (request && !request.error) actions.setApis(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
  setForFrontPage: action((state, payload) => {
    state.forFrontPage = payload;
  }),
  getFrontPage: thunk(async (actions, payload) => {
    try {
      const request = await fetchApis({ limit: 2, sort: { date: "DESC" } });
      if (request && !request.error) actions.setForFrontPage(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
  getApisCount: thunk(async (actions, payload) => {
    try {
      const request = await fetchApisCount(payload);
      if (request && !request.error) actions.setTotalCount(request);
    } catch (err) {
      actions.setError(err);
    }
  }),
};
